import { Assets } from '../core/Assets';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import { Trampopeau } from './Trampopeau';
import { autobind } from 'frontools/decorators/Autobind';
import EventType from 'frontools/events/EventType';
import NumberUtils from 'frontools/utils/NumberUtils';  

export class Bad extends AbstractDispatcher {

    public static HIT_TRAMPO       :       string       = "HIT_TRAMPO";
    public static HIT_SKIN         :       string       = "HIT_SKIN";

    private _scale          :       number;       

    private _game           :       Trampopeau          = Trampopeau.instance;

    private _container      :       PIXI.Container;
    private _sprite         :       PIXI.extras.AnimatedSprite;
    // private _blurSprite     :       PIXI.extras.AnimatedSprite;
    // private _blurFilter      :       PIXI.filters.BlurFilter;

    private _speedDelay     :       number          = 2.5;
    private _tween          :       TweenMax;

    constructor(badNumber:number) {
        super();
        this._sprite =  Assets.getSpriteFromJson('bad'+badNumber);       
       
        this._sprite.loop = false;  

        this._scale = (badNumber === 2) ? 0.8 : 0.9;    
        this._sprite.scale.x = this._scale;
        this._sprite.scale.y = this._scale;

        this._sprite.y = -this._sprite.height;  
        this._sprite.pivot.x =  this._sprite.width / 2; 
        this._sprite.pivot.y =  this._sprite.height-20;       
        
        // this._sprite.x = this._game.screenWidth / 2;   // Generate on center    
        this._sprite.x = NumberUtils.random(20, this._game.screenWidth-20);
        this._tween = TweenMax.to(this._sprite, this._speedDelay, {y: this._game.screenHeight,  ease: Linear.easeNone,
            onUpdate: this._onUpdate    
        });    

        this._container = new PIXI.Container();
        this._container.addChild(this._sprite);

        // Motion blur

        // this._blurSprite = Assets.getSpriteFromJson('bad'+badNumber);    
        // this._blurSprite.loop = false;
        // this._blurSprite.width = this._sprite.width*0.5;
        // this._blurSprite.height = this._sprite.height*1.2;
        // this._blurSprite.pivot.x =  this._sprite.width / 2; 
        // this._blurSprite.pivot.y =  this._sprite.height;     
        // this._blurSprite.y = this._sprite.y - 20;
        // this._blurSprite.x = this._sprite.x;
        // this._blurSprite.alpha = 0.8;
        // this._blurFilter = new PIXI.filters.BlurFilter();
        // this._blurSprite.filters = [this._blurFilter];
        // this._container.addChild(this._blurSprite);
    }

    @autobind
    private _onUpdate(e) {
        this._tween.timeScale( this._game.timeScale )   
        // this._blurSprite.y=this._sprite.y-(this._tween.progress()*10);

        // Collision detection
        var maxX = this._game.getTrampoHitZone().max;  
        var minX = this._game.getTrampoHitZone().min;
        var skinY = this._game.skinY;  
        var trampoY = this._game.trampoY;  
        if (this._sprite.y >= trampoY) { 
            if ((this._sprite.x > minX) && (this._sprite.x < maxX) && (this._sprite.y < trampoY+30)) {
                this._hitTrampo();
            } else if (this._sprite.y >= skinY) {    
                this._hitSkin();
            } 
        }
    }

    private _hitTrampo() {
        this.dispatch({type:Bad.HIT_TRAMPO, bad:this}); 
        this._tween.kill();

        var positionX = Math.random() < 0.5 ? this._game.screenWidth+100 : -100;
        var positionY = (this._game.trampoY-100) - (this._game.timeScale*100);    
        this._sprite.pivot.y =  this._sprite.height / 2; 
        var angle = (positionX > 0) ? 90 : -90;
        var rotation = angle * (Math.PI / 180);

        TweenMax.to(this._sprite, 0.8, { x: positionX});   
        TweenMax.to(this._sprite, 0.8, { rotation: rotation, delay: 0.05});    
        TweenMax.to(this._sprite, 0.4, { y: positionY,          
            onComplete: this._delete       
        });    

        // this._blurSprite.pivot.y =  this._blurSprite.height / 2; 
        // this._blurSprite.y = this._sprite.y + this._sprite.height + 10;
        // TweenMax.to(this._blurSprite, 0.8, { x: positionX});   
        // TweenMax.to(this._blurSprite, 0.8, { rotation: rotation, delay: 0.05});    
        // TweenMax.to(this._blurSprite, 0.4, { y: positionY});    
    }

    private _hitSkin() {
        this.dispatch({type:Bad.HIT_SKIN, bad:this});
        this._tween.kill(); 
        this._sprite.gotoAndStop(1);
        this._sprite.scale.x = this._scale;
        this._sprite.scale.y = this._scale; 
    }

    @autobind
    private _delete() {
        // this._container.removeChild(this._blurSprite); 
        this._container.removeChild(this._sprite); 
        this._game.badsContainer.removeChild(this._container); 
    }

    public get sprite() : PIXI.extras.AnimatedSprite {
        return this._sprite;    
    }

    // public get blurSprite() : PIXI.extras.AnimatedSprite {
    //     return this._blurSprite;    
    // }

    public get container() : PIXI.Container {
        return this._container;    
    }

}